<template>
  <div>
    <!-- 不是编辑状态下的展示 -->
    <a-form
      v-if="!showEditBox"
      class="searchBox"
    >
      <a-row>
        <!-- 名称 -->
        <a-col :span="3">
          {{ $t('admin-message-message/name') }}
        </a-col>
        <!-- 奖项名称输入框 -->
        <a-col :span="9">
          <a-input
            v-model="searchWord"
            :placeholder="$t('admin-rewards-rewards/awardsn')"
          />
        </a-col>
        <!-- 搜索按钮 -->
        <a-col :span="6">
          <a-button
            type="primary"
            @click="getList"
          >
            {{ $t("user-productInfo-myProduct/search") }}
          </a-button>
        </a-col>
        <!-- 添加奖项按钮 -->
        <a-col :span="6">
          <a-button
            type="primary"
            style="float: right;"
            @click="add"
          >
            {{ $t("setting-awards/add") }}
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <!-- 表格信息 -->
    <a-table
      v-if="!showEditBox"
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 编辑时间的图标 -->
      <span
        slot="edit"
        slot-scope="text, row"
        class="edit"
        @click="edit(row)"
      >
        <svg-icon icon-class="write" />
      </span>
      <!-- 时间 -->
      <span
        slot="time"
        slot-scope="text, row"
      >
        {{ row.sign_start_date }} ——— {{ row.sign_end_date }}
      </span>
    </a-table>
    <!-- 编辑状态下的盒子 -->
    <div
      v-if="showEditBox"
      class="editBox"
    >
      <a-form-model
        ref="ruleForm"
        class="ant-advanced-search-form"
        :model="form"
        :rules="rules"
      >
        <a-row :gutter="24">
          <!-- 名称 -->
          <a-col span="12">
            <a-form-model-item
              ref="title"
              prop="title"
              :label="$t('admin-message-message/name')"
              required
            >
              <a-input v-model="form.title" />
            </a-form-model-item>
          </a-col>
          <!-- 简称 -->
          <a-col span="12">
            <a-form-model-item
              ref="short"
              prop="short"
              :label="$t('setting-awards/short')"
              required
            >
              <a-input v-model="form.short" />
            </a-form-model-item>
          </a-col>
          <!-- 报名开始时间 -->
          <a-col span="12">
            <a-form-model-item
              ref="sign_start_date"
              prop="sign_start_date"
              :label="$t('setting-awards-edit/start')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.sign_start_date ? moment(form.sign_start_date) : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) => (form.sign_start_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <!-- 报名结束时间 -->
          <a-col span="12">
            <a-form-model-item
              ref="sign_end_date"
              prop="sign_end_date"
              :label="$t('setting-awards-edit/end')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.sign_end_date ? moment(form.sign_end_date) : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) => (form.sign_end_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <!-- 初评开始时间 -->
          <a-col span="12">
            <a-form-model-item
              ref="review_start_date"
              prop="review_start_date"
              :label="$t('admin-judge/reviewStartDate')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.review_start_date
                    ? moment(form.review_start_date)
                    : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) =>
                    (form.review_start_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <!-- 初评结束时间 -->
          <a-col span="12">
            <a-form-model-item
              ref="review_end_date"
              prop="review_end_date"
              :label="$t('admin-judge/reviewEndDate')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.review_end_date
                    ? moment(form.review_end_date)
                    : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) => (form.review_end_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col span="24">
            <a-form-model-item
              ref="nomination_score"
              prop="nomination_score"
              :label="$t('admin-judge/nominationScore')"
              required
              style="width: calc(50% - 12px);"
            >
              <a-input v-model="form.nomination_score" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="nomination_start_date"
              prop="nomination_start_date"
              :label="$t('admin-rewards-rewards/reviewbg')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.nomination_start_date
                    ? moment(form.nomination_start_date)
                    : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) =>
                    (form.nomination_start_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="nomination_end_date"
              prop="nomination_end_date"
              :label="$t('admin-rewards-rewards/reviewov')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.nomination_end_date
                    ? moment(form.nomination_end_date)
                    : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) => (form.nomination_end_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col span="24">
            <a-form-model-item
              ref="amount"
              prop="amount"
              :label="$t('admin-profile-edit/nomination')"
              required
            >
              <a-input v-model="form.amount" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col span="12">
            <a-form-model-item
              ref="pay_start_date"
              prop="pay_start_date"
              :label="$t('admin-rewards-rewards/servicebg')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.pay_start_date ? moment(form.pay_start_date) : null
                "
                style="width: 100%"
                @change="
                  (data, dataString) => (form.pay_start_date = dataString)
                "
              />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="pay_end_date"
              prop="pay_end_date"
              :label="$t('admin-rewards-rewards/serviceov')"
              required
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.pay_end_date ? moment(form.pay_end_date) : null
                "
                style="width: 100%"
                @change="(data, dataString) => (form.pay_end_date = dataString)"
              />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col span="12">
            <a-form-model-item
              ref="product_start_date"
              prop="product_start_date"
              :label="$t('view-components-components/startEdit')"
            >
              <a-date-picker
                placeholder=""
                :default-value="
                  form.product_start_date ? moment(form.product_start_date) : null
                "
                style="width: 100%"
                @change="(data, dataString) => (form.product_start_date = dataString)"
              />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="product_end_date"
              prop="product_end_date"
              :label="$t('view-components-components/endEdit')"
            >
              <a-date-picker
                placeholder=""
                :default-value="form.product_end_date ? moment(form.product_end_date) : null"
                style="width: 100%"
                @change="(data, dataString) => (form.product_end_date = dataString)"
              />
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
    </div>
    <!-- 保存按钮 -->
    <footer v-if="showEditBox">
      <a-button @click="save">
        {{ $t("admin-profile-edit/save") }}
      </a-button>
    </footer>
  </div>
</template>
<script>
// 导入日期处理
import moment from 'moment'
// 导入奖项名称函数，创建名称函数，编辑名称函数
import { awards, createAwards, editAwards } from '@/api/awards'
// 导入两个语言化资源
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
// 导入cookie值获取函数
import { getLKey } from '@/utils/auth'
// 本地化数据变量
const i18n = { zh, en }
// 获取cookie值
const lang = getLKey()
// 列头数据
const columns = [
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '时间',
    dataIndex: 'sign_start_date',
    key: 'sign_start_date',
    scopedSlots: { customRender: 'time' }
  },
  {
    title: '',
    dataIndex: 'id',
    key: 'id',
    scopedSlots: { customRender: 'edit' }
  }
]

export default {
  data() {
    return {
      moment, // 日期处理
      searchWord: '', // 搜索关键字
      pagination: { // 页码总行数数据
        current: 1,
        total: 0
      },
      labelCol: { span: 7 }, // labelcol占据宽度
      wrapperCol: { span: 12 }, // 空间空出来的宽度
      number: { // 未知，暂时没用
        value: 11
      },
      data: [], // 表格数据
      columns, // 列头数据
      form: { // form表单数据
        title: '', // 名称
        short: '', // 简称
        sign_start_date: '', // 报名开始时间
        sign_end_date: '', // 报名结束时间
        review_start_date: '', // 初评开始时间
        review_end_date: '', // 初评结束时间
        // nomination_score: '',
        // nomination_start_date: '',
        // nomination_end_date: '',
        // pay_start_date: '',
        // pay_end_date: '',
        amount: '' // 暂时没用，注释掉了
      },
      rules: { // 转换所有的数据
        title: [ // 名称
          { required: true, message: this.$t('admin-rewards-rewards/pname'), trigger: ['blur', 'change'] }
        ],
        short: [ // 简称
          { required: true, message: this.$t('admin-rewards-rewards/abbreviation'), trigger: ['blur', 'change'] }
        ],
        sign_start_date: [ // 报名开始时间
          {
            required: true,
            message: this.$t('admin-rewards-rewards/signupbg'),
            trigger: ['blur', 'change']
          }
        ],
        sign_end_date: [ // 报名结束时间
          {
            required: true,
            message: this.$t('admin-rewards-rewards/signupov'),
            trigger: ['blur', 'change']
          }
        ],
        review_start_date: [ // 初评开始时间
          {
            required: true,
            message: this.$t('admin-judge/tip20'),
            trigger: ['blur', 'change']
          }
        ],
        review_end_date: [ // 初评结束时间
          {
            required: true,
            message: this.$t('admin-judge/tip21'),
            trigger: ['blur', 'change']
          }
        ],
        // nomination_score: [
        //   { required: true, message: this.$t('admin-judge/tip22'), trigger: ['blur', 'change'] }
        // ],
        // nomination_start_date: [
        //   {
        //     required: true,
        //     message: this.$t('admin-rewards-rewards/previewbg'),
        //     trigger: ['blur', 'change']
        //   }
        // ],
        // nomination_end_date: [
        //   {
        //     required: true,
        //     message: this.$t('admin-rewards-rewards/previewov'),
        //     trigger: ['blur', 'change']
        //   }
        // ],
        // pay_start_date: [
        //   {
        //     required: true,
        //     message: this.$t('admin-rewards-rewards/pservicebg'),
        //     trigger: ['blur', 'change']
        //   }
        // ],
        // pay_end_date: [
        //   {
        //     required: true,
        //     message: this.$t('admin-rewards-rewards/pserviceov'),
        //     trigger: ['blur', 'change']
        //   }
        // ],
        amount: [
          {
            required: true,
            message: this.$t('admin-rewards-rewards/reassessmentfee'),
            trigger: ['blur', 'change']
          }
        ]
      },
      showEditBox: false, // 是否展示编辑状态的盒子
      id: '' // 编辑作品的id
    }
  },
  computed: {
    locale() { // 语言化
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) { // 语言化对非编辑盒子的名称和时间
      console.log(e) // 根据e对变量重新赋值
      this.columns[0].title = this.$t('admin-message-message/name')
      this.columns[1].title = this.$t('admin-profile-log/time')
      // this.columns[2].title = this.$t("user-tools/code");
    }
  },
  created() { // 语言化对非编辑盒子的名称和时间
    this.columns[0].title = this.$t('admin-message-message/name')
    this.columns[1].title = this.$t('admin-profile-log/time')
    // this.columns[2].title = this.$t("user-tools/code");
    this.getList() // 执行初始化数据
  },
  methods: {
    getList(page) { // 判断有无数据传来，没有用1做变量的初始值
      const params = {
        search: this.searchWord,
        page: typeof page === 'number' ? page : 1
      }
      awards(params)
        .then(res => { // 奖项信息获取，通过传入参数，并存储表格总行数和页码数据
          this.data = res.data
          this.pagination.total = res.total
          this.pagination.current = res.current_page
        })
        .catch(res => { // 有错报错
          console.error(res)
        })
    },
    add() { // 对当前数据进行重置，且展示编辑盒子
      this.id = ''
      this.showEditBox = true
    },
    edit(row) { // 把选中的行id赋值给变量id，行的其他数据也赋值给form表单数据
      this.id = row.id
      this.form.title = row.title
      this.form.short = row.short
      this.form.sign_start_date = row.sign_start_date
      this.form.sign_end_date = row.sign_end_date
      this.form.review_start_date = row.review_start_date
      this.form.review_end_date = row.review_end_date
      // this.form.nomination_score = row.nomination_score
      // this.form.nomination_start_date = row.nomination_start_date
      // this.form.nomination_end_date = row.nomination_end_date
      this.form.pay_start_date = row.pay_start_date // 暂时没用到
      // this.form.pay_end_date = row.pay_end_date
      this.form.amount = row.amount // 暂时没用到
      this.form.product_start_date = row.product_start_date // 暂时没用到
      this.form.product_end_date = row.product_end_date // 暂时没用到
      this.showEditBox = true // 展示编辑盒子
    },
    save() { // 点击编辑盒子的保存执行函数，判断时间选择的是否适当，不适当报错
      const data = JSON.parse(JSON.stringify(this.form))

      if (
        // new Date(data.pay_end_date) <= new Date(data.pay_start_date) ||
        new Date(data.review_end_date) <= new Date(data.review_start_date) ||
        // new Date(data.nomination_end_date) <= new Date(data.nomination_start_date) ||
        new Date(data.sign_end_date) <= new Date(data.sign_start_date)
      ) {
        return this.$message.error({
          content: i18n[lang]['admin-rewards-rewards/ovbg'],
          key: 'message',
          duration: 2
        })
      }
      // if (new Date(data.pay_start_date) <= new Date(data.nomination_end_date)) {
      //   return this.$message.error({
      //     content: i18n[lang]['admin-rewards-rewards/servicereviewbg'],
      //     key: 'message',
      //     duration: 2
      //   })
      // }
      if (
        new Date(data.review_start_date) <= new Date(data.sign_end_date)
      ) {
        return this.$message.error({
          content: this.$t('admin-judge/tip23'),
          key: 'message',
          duration: 2
        })
      }
      // if (
      //   new Date(data.nomination_start_date) <= new Date(data.review_end_date)
      // ) {
      //   return this.$message.error({
      //     content: this.$t('admin-judge/tip24'),
      //     key: 'message',
      //     duration: 2
      //   })
      // }
      this.$refs.ruleForm.validate(async valid => {
        if (valid) { // 如果valid存在就执行更改名称函数，即，更改所有数据，否则执行更改时间函数
          if (!this.id) {
            createAwards(data)
              .then(() => {
                this.$message.success({
                  content: i18n[lang]['admin-password-password/savey'],
                  key: 'message',
                  duration: 2
                })
                this.showEditBox = false
                this.getList()
              })
              .catch(res => {
                console.error(res)
              })
          } else {
            const id = this.id
            editAwards(id, data)
              .then(() => {
                this.$message.success({
                  content: i18n[lang]['admin-rewards-rewards/modify'],
                  key: 'message',
                  duration: 2
                })
                this.showEditBox = false
                this.getList()
              })
              .catch(res => {
                console.error(res)
              })
          }
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    },
    pageChange(e) { // 当页码发生变化时，更新当前表格展示数据
      this.getList(e.current)
    }
  }
}
</script>
<style scoped>
.searchBox {
  background: #ffffff;
  height: 100px;
  line-height: 32px;
  box-sizing: border-box;
  padding: 30px 20px;
  margin-bottom: 24px;
}

.searchBox .ant-form-item {
  margin-bottom: 0;
}

.edit {
  cursor: pointer;
}

.editBox {
  position: absolute;
  top: 0;
  background: #f8f8f8;
  padding-right: 25px;
  padding-bottom: 90px;
}

.subTitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 17px;
}

.tip {
  font-size: 14px;
  color: #999999;
  margin-top: 4px;
  line-height: 14px;
}

footer {
  width: 100%;
  height: 70px;
  text-align: right;
  padding: 19px 24px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  right: 0;
}

footer button {
  margin-left: 16px;
}
</style>
